<template>
  <div class="auto-save-component"></div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: 'AutoSave',
  props: [
    'messages',
    'callback'
  ],
  data () {
    const autoSaveInterval = null
    return {
      autoSaveInterval
    }
  },
  mounted () {
    this.autoSaveInterval = setInterval(this.testCall, 60000 * 5) // 5 min
  },
  unmounted () {
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval)
    }
  },
  methods: {
    testCall () {
      this.callback.invokeMethodAsync('AutoSaveCv', Math.floor(Date.now() / 1000) + '')
      // .then(r => console.log(r))
    }
  }
}
</script>
